// context/SearchContext.js
import React, { createContext, useContext, useState, useCallback } from 'react';

const SearchContext = createContext();

export const useSearch = () => {
  const context = useContext(SearchContext);
  if (!context) {
    throw new Error('useSearch must be used within a SearchProvider');
  }
  return context;
};

export const SearchProvider = ({ children }) => {
  const [searchState, setSearchState] = useState({
    searchQuery: '',
    currentPage: ''
  });

  const updateSearch = useCallback((query, page = '') => {
    setSearchState(prev => {
      // Only update if something actually changed
      if (query === prev.searchQuery && page === prev.currentPage) {
        return prev;
      }
      
      return {
        searchQuery: query,
        currentPage: page || prev.currentPage
      };
    });
  }, []);

  const clearSearch = useCallback(() => {
    setSearchState(prev => ({ ...prev, searchQuery: '' }));
  }, []);

  const value = {
    searchQuery: searchState.searchQuery,
    currentPage: searchState.currentPage,
    updateSearch,
    clearSearch
  };

  return (
    <SearchContext.Provider value={value}>
      {children}
    </SearchContext.Provider>
  );
};